import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import rentalSlice from './slices/rentalSlice';
import orderSlice from './slices/orderSlice';
import rideSlice from './slices/rideSlice';
import franchiseSlice from './slices/franchiseSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    rental: rentalSlice,
    order: orderSlice,
    ride: rideSlice,
    franchise: franchiseSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;